import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDuplicateThemeMutation = createMutationHook(ShopRendererApiClient.duplicateTheme, {
  mutationKey: ['duplicateTheme'],
})
